import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthContext';
import { AppToaster } from '@/components/AppToaster';
import { queryClient } from '@/lib/queryClient';
import { router } from '@/routes/router';

/**
 * Composition root. Provider order: TanStack Query (server-state) → Auth
 * (registers the API token provider) → Router (renders guarded routes).
 */
export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
        <AppToaster />
      </AuthProvider>
    </QueryClientProvider>
  );
}
